import { config, msg } from 'api';
import {
  amendChangeDeliveryToCustomerMessages,
  deleteCustomerMessage,
} from 'apps/customerMessages/actions/customerMessages';
import { UNKNOWN_ERROR } from 'utils/errors';

const url = `${config.apiBasePath}/delivery-slot`;

export const RECEIVE_DELIVERY_SLOT = 'RECEIVE_DELIVERY_SLOT';
export const RECEIVE_DELIVERY_SLOT_ERROR = 'RECEIVE_DELIVERY_SLOT_ERROR';

export function receiveDeliverySlot(deliverySlot) {
  return {
    type: RECEIVE_DELIVERY_SLOT,
    deliverySlot,
  };
}

export function receiveDeliverySlotError(json) {
  return {
    type: RECEIVE_DELIVERY_SLOT_ERROR,
    error: json.error,
  };
}

export function fetchDeliverySlot() {
  const { changeDelivery } = msg.mobileNotifications;
  return (dispatch, store, { network }) => network
    .get(url)
    .then((data) => {
      dispatch(receiveDeliverySlot(data));
      if (data && data.expirationTime) {
        dispatch(amendChangeDeliveryToCustomerMessages(data));
      } else {
        dispatch(deleteCustomerMessage({ id: changeDelivery.id }));
      }
      return data;
    })
    .catch(err => {
      dispatch(receiveDeliverySlotError(err.data || UNKNOWN_ERROR));
      dispatch(deleteCustomerMessage({ id: changeDelivery.id }));
      return false;
    });
}
